import { useAuthInfiniteList } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { UserApi } from 'api';
import { IUserListItem, SearchUserFilterType } from 'types';
import { KEY } from './keys';

function useGetInfinite(filter: SearchUserFilterType, size = 30) {
  return useAuthInfiniteList<IUserListItem>(
    [...getQueryKeys([KEY]).lists(), 'infinite', { ...filter, size }],
    (page) => UserApi.getAll({ ...filter, page, size }),
  );
}

export default useGetInfinite;
